enum OrderType {
    "ALL" = "ALL",

    "DROP_SHIPPING_ORDER" = "DROP_SHIPPING_ORDER",

    "ORDINARY_ORDER" = "ORDINARY_ORDER",
}

export function getOrderTypeName(orderType: OrderType) {
    switch (orderType) {
        case OrderType.DROP_SHIPPING_ORDER:
            return "代发订单";
        case OrderType.ORDINARY_ORDER:
            return "自有订单";
        case OrderType.ALL:
        default:
            return "全部订单";
    }
}

export default OrderType;
